import { _ep0, _mw0, command } from "../commandBuilder";
import { RemoveManagerFromChurch$ } from "../schemas/schemas_0";
export class RemoveManagerFromChurchCommand extends command(_ep0, _mw0, "RemoveManagerFromChurch", RemoveManagerFromChurch$) {
}
